var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"row-style-class":_vm.rowStyleGrupos,"search-options":{
        enabled: false,
        skipDiacritics: true,
        placeholder: 'Buscar en la tabla',
      },"sort-options":{
        enabled: true,
        initialSortBy: { field: 'alias', type: 'asc' },
      },"pagination-options":{
        enabled: true,
        mode: 'records',
        perPage: 5,
        dropdownAllowAll: false,
        //setCurrentPage: 2,
        nextLabel: '',
        prevLabel: '',
        rowsPerPageLabel: 'Filas por pagina',
        ofLabel: 'de',
        pageLabel: 'pagina', // for 'pages' mode
        allLabel: 'Todas',
      },"isLoading":_vm.isLoading},on:{"on-row-click":_vm.loadView,"update:isLoading":function($event){_vm.isLoading=$event},"update:is-loading":function($event){_vm.isLoading=$event}},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'acciones')?_c('span',[_c('span',{staticStyle:{"margin-right":"10px"},on:{"click":function($event){return _vm.viewRow(props.row.uuid)}}},[_c('i',{staticClass:"far fa-eye fa-lg",staticStyle:{"cursor":"pointer"},attrs:{"title":"Ampliar detalles de agrupación"}})]),_c('span',{staticStyle:{"margin-right":"10px"},on:{"click":function($event){return _vm.editRow(props.row.uuid)}}},[_c('i',{staticClass:"far fa-edit fa-lg",staticStyle:{"cursor":"pointer"},attrs:{"title":"Editar detalles de agrupación"}})]),(_vm.isUserAdmin())?_c('span',{on:{"click":function($event){return _vm.deleteModalPopup(props.row.uuid)}}},[_c('i',{staticClass:"far fa-trash-alt fa-lg",staticStyle:{"cursor":"pointer"},attrs:{"title":"Borrar detalles de agrupación"}})]):_vm._e()]):_vm._e()]}}])},[_c('template',{slot:"loadingContent"},[_c('table-loading')],1),_c('template',{slot:"emptystate"},[_c('table-empty-state')],1)],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }